import { APIClient, ApiQueryParams, buildApiEndpoint } from '@frontend/api-utils';
import { SettingTemplateResult } from '@frontend/setting/types';

export class SettingTemplateClient extends APIClient {
    public static readonly endpoint = '/setting-api/v1';

    public static async fetchSettingTemplates(queryParams?: ApiQueryParams<any>): Promise<SettingTemplateResult> {
        const url = buildApiEndpoint(`${this.endpoint}/setting-templates`, { ...queryParams });
        const response = await this.fetch(url);
        return await this.handleResponse<SettingTemplateResult>(response);
    }
}
